import { IDelivery } from '../../../utils/types';
import { IDeliverForm } from '../types';

export const parseHistoryState = (): Partial<IDeliverForm> => {
    const data: IDelivery | undefined = globalThis.history.state?.usr?.delivery;
    if (!data?.id) {
        return {
            options: [],
        };
    }

    return {
        id: data.id,
        name: data.name,
        price: +data.price,
        options: data.options?.map((item) => ({ value: item })) || [],
        visible: !data.deletedAt,
    };
};
